module.exports = __webpack_public_path__ + "img/박세연 아티스트.b50bcfb8.jpg";